import darkMode, { colorScaleDark } from './darkMode';
import lightMode, { colorScaleLight } from './lightMode';
import nuttallMode, { colorScaleNutall } from './nuttallMode';
import hengelMode, { colorScaleHengel } from './hengelMode';
import ocfMode, { colorScaleOCF } from './ocfMode';
import lightCloudMode, { colorScaleCloudLight } from './lightCloudMode';

import {
  COLOR_SCALE_PRIMARY,
  COLOR_SCALE_SECONDARY,
  COLOR_SCALE_ACCENT_1,
  COLOR_SCALE_ACCENT_2,
  COLOR_SCALE_ACCENTS_COLORS,
  COLOR_SCALE_PRIMARY_COLORS,
  COLOR_SCALE_CHARTS_COLORS,
  COLOR_SCALE_CHARTS_DIGITAL_CHANNELS_COLORS,
  COLOR_SCALE_LOGO_COLORS,
} from './Constants';

export const MODE_DARK = 'MODE_DARK';
export const MODE_CLOUD_LIGHT = 'MODE_CLOUD_LIGHT';
export const MODE_LIGHT = 'MODE_LIGHT';
export const MODE_NUTTALL = 'MODE_NUTTALL';
export const MODE_HENGEL = 'MODE_HENGEL';
export const MODE_OCF = 'MODE_OCF';
export type MODE_UI_OPTIONS =
  | typeof MODE_DARK
  | typeof MODE_LIGHT
  | typeof MODE_CLOUD_LIGHT
  | typeof MODE_NUTTALL
  | typeof MODE_HENGEL
  | typeof MODE_OCF;

export {
  COLOR_SCALE_PRIMARY,
  COLOR_SCALE_SECONDARY,
  COLOR_SCALE_ACCENT_1,
  COLOR_SCALE_ACCENT_2,
  COLOR_SCALE_ACCENTS_COLORS,
  COLOR_SCALE_PRIMARY_COLORS,
  COLOR_SCALE_CHARTS_COLORS,
  COLOR_SCALE_CHARTS_DIGITAL_CHANNELS_COLORS,
  COLOR_SCALE_LOGO_COLORS,
};

let defaultMode: MODE_UI_OPTIONS = MODE_LIGHT;
export const getDefaultMode = () => {
  return defaultMode;
};
export const setDefaultMode = (newMode: MODE_UI_OPTIONS) => {
  defaultMode = newMode;
};

/**
 * Colors mode UI
 * This function returns the interface colors
 * @param string mode [MODE_DARK, MODE_LIGHT]
 * @return object colors
 */
export const colorsModeUI = (mode: MODE_UI_OPTIONS = defaultMode) => {
  if (!mode) mode = defaultMode;
  switch (mode) {
    case MODE_DARK:
      return darkMode();
    case MODE_LIGHT:
      return lightMode();
    case MODE_CLOUD_LIGHT:
      return lightCloudMode();
    case MODE_NUTTALL:
      return nuttallMode();
    case MODE_HENGEL:
      return hengelMode();
    case MODE_OCF:
      return ocfMode();

    default:
      return lightMode();
  }
};

/**
 * colors scale
 *
 * @param string mode [MODE_DARK, MODE_LIGHT]
 * @param int totalColors: number of colors to return
 * @param option [
 *  COLOR_SCALE_PRIMARY_COLORS: gradient using the primary colors,
 *  COLOR_SCALE_ACCENTS_COLORS: gradient using the accent colors,
 *  COLOR_SCALE_LOGO_COLORS: gradient using the logo colors,
 *  COLOR_SCALE_PRIMARY: gradient using white and the primary color,
 *  COLOR_SCALE_SECONDARY: gradient using white and secondary color ,
 *  COLOR_SCALE_ACCENT_1: gradient using white and accent color 1,
 *  COLOR_SCALE_ACCENT_2: gradient using white and accent color 2,
 * ]
 * @return object colorsScale
 */
export const colorsScale = (
  mode: MODE_UI_OPTIONS | undefined = defaultMode,
  totalColors: number,
  option: string | undefined
) => {
  if (!mode) mode = defaultMode;
  switch (mode) {
    case MODE_DARK:
      return colorScaleDark(totalColors, option);
    case MODE_LIGHT:
      return colorScaleLight(totalColors, option);
    case MODE_CLOUD_LIGHT:
      return colorScaleCloudLight();
    case MODE_NUTTALL:
      return colorScaleNutall(totalColors, option);
    case MODE_HENGEL:
      return colorScaleHengel(totalColors, option);
    case MODE_OCF:
      return colorScaleOCF(totalColors, option);
    default:
      return colorScaleLight(totalColors, option);
  }
};

/**
 * Color modes
 * this function the existing color modes ui
 * @return array colorsModes
 */
export const colorsModes = () => [
  MODE_DARK,
  MODE_LIGHT,
  MODE_CLOUD_LIGHT,
  MODE_NUTTALL,
  MODE_HENGEL,
  MODE_OCF,
];
